import { render, staticRenderFns } from "./media_item.vue?vue&type=template&id=64dc4eb4&scoped=true"
import script from "./media_item.vue?vue&type=script&lang=js"
export * from "./media_item.vue?vue&type=script&lang=js"
import style0 from "./media_item.vue?vue&type=style&index=0&id=64dc4eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc4eb4",
  null
  
)

export default component.exports